export enum Privileges {
   ManageUsersAndPrivileges_Add = 'ManageUsersAndPrivileges_Add',

   ManageUsersAndPrivileges_Edit = 'ManageUsersAndPrivileges_Edit',

   ManageUsersAndPrivileges_View = 'ManageUsersAndPrivileges_View',

   ManageUsersAndPrivileges_Delete = 'ManageUsersAndPrivileges_Delete',

   ManageUsersAndPrivileges_ListItem = 'ManageUsersAndPrivileges_ListItem',

   ManageAccountPrompts_Add = 'ManageAccountPrompts_Add',

   ManageAccountPrompts_Edit = 'ManageAccountPrompts_Edit',

   ManageAccountPrompts_View = 'ManageAccountPrompts_View',

   ManageAccountPrompts_Delete = 'ManageAccountPrompts_Delete',

   ManageDevices_Add = 'ManageDevices_Add',

   ManageDevices_Edit = 'ManageDevices_Edit',

   ManageDevices_View = 'ManageDevices_View',

   ManageDevices_Delete = 'ManageDevices_Delete',

   ManageSystemPrompts_Add = 'ManageSystemPrompts_Add',

   ManageSystemPrompts_Edit = 'ManageSystemPrompts_Edit',

   ManageSystemPrompts_View = 'ManageSystemPrompts_View',

   ManageSystemPrompts_Delete = 'ManageSystemPrompts_Delete',

   ManageExtensions_Enabled = 'ManageExtensions_Enabled',

   ManageExtensions_ListItem = 'ManageExtensions_ListItem',

   ManageAccounts_Add = 'ManageAccounts_Add',

   ManageAccounts_Delete = 'ManageAccounts_Delete',

   ManageAccountSettings_View = 'ManageAccountSettings_View',

   ManageAccountSettings_Edit = 'ManageAccountSettings_Edit',

   ManageUserPreferences_Add = 'ManageUserPreferences_Add',

   ManageUserPreferences_Edit = 'ManageUserPreferences_Edit',

   ManageUserPreferences_View = 'ManageUserPreferences_View',

   ManageUserPreferences_Delete = 'ManageUserPreferences_Delete',

   ManageSystemLogs_Add = 'ManageSystemLogs_Add',

   ManageSystemLogs_Edit = 'ManageSystemLogs_Edit',

   ManageSystemLogs_View = 'ManageSystemLogs_View',

   ManageSystemLogs_Delete = 'ManageSystemLogs_Delete',

   ManageServers_Add = 'ManageServers_Add',

   ManageServers_Edit = 'ManageServers_Edit',

   ManageServers_View = 'ManageServers_View',

   ManageServers_Delete = 'ManageServers_Delete',

   ManageCallDetails_View = 'ManageCallDetails_View',

   ManageLocations_Add = 'ManageLocations_Add',

   ManageLocations_Edit = 'ManageLocations_Edit',

   ManageLocations_View = 'ManageLocations_View',

   ManageLocations_Delete = 'ManageLocations_Delete',

   ManageLocationSettings_View = 'ManageLocationSettings_View',

   ManageFileDepots_Add = 'ManageFileDepots_Add',

   ManageFileDepots_Edit = 'ManageFileDepots_Edit',

   ManageFileDepots_View = 'ManageFileDepots_View',

   ManageFileDepots_Delete = 'ManageFileDepots_Delete',

   ManageSchedules_Add = 'ManageSchedules_Add',

   ManageSchedules_Edit = 'ManageSchedules_Edit',

   ManageSchedules_View = 'ManageSchedules_View',

   ManageSchedules_Delete = 'ManageSchedules_Delete',

   ManagePhoneNumbers_Add = 'ManagePhoneNumbers_Add',

   ManagePhoneNumberSettings_Edit = 'ManagePhoneNumberSettings_Edit',

   ManagePhoneNumberSettings_View = 'ManagePhoneNumberSettings_View',

   ManagePhoneNumbers_Delete = 'ManagePhoneNumbers_Delete',

   ManageFiles_Add = 'ManageFiles_Add',

   ManageFiles_Edit = 'ManageFiles_Edit',

   ManageFiles_View = 'ManageFiles_View',

   ManageFiles_Delete = 'ManageFiles_Delete',

   ManageRoles_Add = 'ManageRoles_Add',

   ManageRoles_Edit = 'ManageRoles_Edit',

   ManageRoles_View = 'ManageRoles_View',

   ManageRoles_Delete = 'ManageRoles_Delete',

   ManageExtensionPhones_Add = 'ManageExtensionPhones_Add',

   ManageExtensionPhoneSettings_Edit = 'ManageExtensionPhoneSettings_Edit',

   ManageExtensionPhoneSettings_Delete = 'ManageExtensionPhoneSettings_Delete',

   ManageAzureActiveDirectoryConfigurations_Add = 'ManageAzureActiveDirectoryConfigurations_Add',

   ManageAzureActiveDirectoryConfigurations_Edit = 'ManageAzureActiveDirectoryConfigurations_Edit',

   ManageAzureActiveDirectoryConfigurations_View = 'ManageAzureActiveDirectoryConfigurations_View',

   ManageAzureActiveDirectoryConfigurations_Delete = 'ManageAzureActiveDirectoryConfigurations_Delete',

   ManageOtherExtensions_Add = 'ManageOtherExtensions_Add',

   ManageOtherExtensions_Edit = 'ManageOtherExtensions_Edit',

   ManageOtherExtensions_Delete = 'ManageOtherExtensions_Delete',

   ManageExtensionAutoAttendants_Delete = 'ManageExtensionAutoAttendants_Delete',

   ManageExtensionAutoAttendants_Edit = 'ManageExtensionAutoAttendants_Edit',

   ManageExtensionAutoAttendants_View = 'ManageExtensionAutoAttendants_View',

   ManageExtensionAutoAttendants_Add = 'ManageExtensionAutoAttendants_Add',

   ManageExtensionGroups_Delete = 'ManageExtensionGroups_Delete',

   ManageExtensionGroups_Edit = 'ManageExtensionGroups_Edit',

   ManageExtensionGroups_Add = 'ManageExtensionGroups_Add',

   ManageReports_Enabled = 'ManageReports_Enabled',

   ManageCallRecordings_Enabled = 'ManageCallRecordings_Enabled',

   ManageLCSCallRecordings_Enabled = 'ManageLCSCallRecordings_Enabled',

   ManageSystemUsers_Add = 'ManageSystemUsers_Add',

   ManageSystemUsers_Edit = 'ManageSystemUsers_Edit',

   ManageSystemUsers_View = 'ManageSystemUsers_View',

   ManageSystemUsers_Delete = 'ManageSystemUsers_Delete',

   ManageSystemRoles_Add = 'ManageSystemRoles_Add',

   ManageSystemRoles_Edit = 'ManageSystemRoles_Edit',

   ManageSystemRoles_View = 'ManageSystemRoles_View',

   ManageSystemRoles_Delete = 'ManageSystemRoles_Delete',

   HangUpCalls_Enabled = 'HangUpCalls_Enabled',

   ManageProviderCallRates_Add = 'ManageProviderCallRates_Add',

   ManageProviderCallRates_Edit = 'ManageProviderCallRates_Edit',

   ManageProviderCallRates_View = 'ManageProviderCallRates_View',

   ManageProviderCallRates_Delete = 'ManageProviderCallRates_Delete',

   ManageExtensionSupervisees_Enabled = 'ManageExtensionSupervisees_Enabled',

   ManageExtensionFaxes_Add = 'ManageExtensionFaxes_Add',

   ManageExtensionFaxes_Edit = 'ManageExtensionFaxes_Edit',

   ManageExtensionFaxes_Delete = 'ManageExtensionFaxes_Delete',

   ManageFaxEmailAddresses_Add = 'ManageFaxEmailAddresses_Add',

   ManageFaxEmailAddresses_Edit = 'ManageFaxEmailAddresses_Edit',

   ManageFaxEmailAddresses_Delete = 'ManageFaxEmailAddresses_Delete',

   ManageBannedAllowedIps_Enabled = 'ManageBannedAllowedIps_Enabled',

   ManageLogLevels_Enabled = 'ManageLogLevels_Enabled',

   RebootPhones_Enabled = 'RebootPhones_Enabled',

   ManagePresenceContacts_Edit = 'ManagePresenceContacts_Edit',

   ManageDepartments_Add = 'ManageDepartments_Add',

   ManageDepartments_Edit = 'ManageDepartments_Edit',

   ManageDepartments_View = 'ManageDepartments_View',

   ManageDepartments_Delete = 'ManageDepartments_Delete',

   ManageDepartmentExtensions_Edit = 'ManageDepartmentExtensions_Edit',

   DeleteCallRecordings_Delete = 'DeleteCallRecordings_Delete',

   ManageActiveCalls_View = 'ManageActiveCalls_View',

   ManageQueueStatus_View = 'ManageQueueStatus_View',
}
